<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :value="value"
    :close-on-content-click="false"
    :nudge-right="40"
    :disabled="schema.disabled || schema.readonly"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <v-text-field
      slot="activator"
      :value="inputValue"
      :label="schema.label"
      :name="schema.fullKey"
      :required="schema.required"
      :rules="rules()"
      :clearable="!schema.required && !schema.disabled && !schema.readonly"
      prepend-icon="event"
      readonly
      @input="emitInput($event)"
    >
      <v-tooltip
        v-if="schema.description && schema.description.length > 0"
        slot="append-outer"
        color="white grey--text"
        left
      >
        <v-icon
          slot="activator"
          style="font-size: 22px;color:white; border-radius:20px"
          class="grey"
          dark
          >info</v-icon
        >
        <div class="vjsf-tooltip" v-html="schema.description" />
      </v-tooltip>

      <!-- begin ref buttons -->
      <v-tooltip
        v-if="refSpecs != null"
        :slot="
          refSpecs.selectBtn != null && refSpecs.selectBtn.placement != null
            ? refSpecs.selectBtn.placement
            : 'append'
        "
        color="white grey--text"
        left
      >
        <v-btn slot="activator" icon class="ma-0" @click="$emit('refShowList')">
          <v-icon>find_replace</v-icon>
        </v-btn>
        <div class="vjsf-tooltip">
          {{
            refSpecs.selectBtn != null && refSpecs.selectBtn.description != null
              ? refSpecs.selectBtn.description
              : 'Select'
          }}
        </div>
      </v-tooltip>
      <v-tooltip
        v-if="refSpecs != null"
        :slot="
          refSpecs.clearBtn != null && refSpecs.clearBtn.placement != null
            ? refSpecs.clearBtn.placement
            : 'append'
        "
        color="white grey--text"
        left
      >
        <v-btn
          slot="activator"
          icon
          class="ma-0"
          @click="$emit('refClearSelection')"
        >
          <v-icon>clear</v-icon>
        </v-btn>
        <div class="vjsf-tooltip">
          {{
            refSpecs.clearBtn != null && refSpecs.clearBtn.description != null
              ? refSpecs.clearBtn.description
              : 'Clear'
          }}
        </div>
      </v-tooltip>
      <!-- end ref buttons -->
    </v-text-field>
    <v-date-picker
      v-model="inputValue"
      :type="(changeType(), changeFormat)"
      :allowed-dates="getAllowedDates"
      no-title
      scrollable
      @input="emitInput($event)"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import { Utils } from '../Utils'
import { DateTime } from 'luxon'
var utils = new Utils()

export default {
  name: 'RDDateWidget',
  props: {
    schema: {
      type: Object,
      required: true
    },
    value: {
      type: String,
      default: null
    },
    refSpecs: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      inputValue: this.getInitialValue(),
      menu: false,
      changeFormat: ''
    }
  },
  methods: {
    getInitialValue() {
      if (this.value != null) {
        return this.value
      }
      let initialValue = null
      if (this.schema.defaultValue != null) {
        if (this.schema.defaultValue === '$currentDate')
          initialValue = DateTime.local().toFormat('yyyy-LL-dd')
        else
          initialValue = Date.fromISO(this.schema.defaultValue).toFormat(
            'yyyy-LL-dd'
          )
      }
      if (initialValue != null) {
        this.emitInput(initialValue)
      }
      return initialValue
    },
    getAllowedDates(val) {
      var val2 = DateTime.fromISO(val).weekdayLong
      if (
        this.schema.restrictedDays !== undefined &&
        this.schema.restrictedDays != null
      ) {
        if (this.schema.restrictedDays.indexOf(val2) !== -1) {
          return false
        } else {
          return true
        }
      }
      return true
    },

    changeType() {
      if (this.schema.format !== undefined) {
        this.changeFormat = 'month'
      } else {
        this.changeFormat = 'date'
      }
    },

    emitInput: function(value) {
      console.log('date widget value: ' + value)
      this.menu = false
      this.inputValue = value
      this.$emit('input', this.inputValue == '' ? null : this.inputValue)
    },

    rules: function() {
      if (this.schema.rules == undefined) return
      var rules = []
      if (this.schema.rules.required == true)
        rules = rules.concat(utils.getRequiredRules())
      return rules
    }
  }
}
</script>
